export const posList = [
  "UNIONPOS",
  "OKPOS",
  "OASIS_POS",
  "EASY_POS",
  "ONL_POS", "DUMMY_POS"
]